import React, { useState } from 'react'
import List from './List'
import Add from './Add'
export default function Main({ handleTabchange, ListData }) {
    const [tab, setTab] = useState("list")
    const [editData, setEditData] = useState({})

    const handleTab = (type, data) => {
        setEditData(data)
        setTimeout(() => {
            setTab(type)
        }, 200)
    }

    return (
        <>
            {tab == "list" ? <List handleTab={handleTab} ListData={ListData} handleTabchange={handleTabchange}/> : ""}
            {tab == "add" ? <Add handleTab={handleTab} editData={editData}  ListData={ListData}/> : ""}
        </>
    )
}
